export enum TreeEventType {
  SaveItem = 'saveItem',
  EditItem = 'editItem',
  MoveToTrash = 'moveToTrash',
  MoveFromTrash = 'moveFromTrash',
  AddChildItem = 'addChildItem',
  OnMovedNode = 'onMovedNode',
  OnViewChange = 'onViewChange',
  ExpandNode = 'expandNode',
  BlurFocusedNode = 'blurFocusedNode'
}

export enum ProcessQueueRequestAction {
  RefreshDashboard = 'refreshDashboard',
  SaveNewChanges = 'saveNewChanges',
  SaveWelcomePopupPreference = 'saveWelcomePopupPreference',
  SaveDashboardTheme = 'saveDashboardTheme'
}

export enum SaveActionType {
  MoveItemToTrash = 'moveItemToTrash',
  MoveItemFromTrash = 'moveItemFromTrash',
  UpdateItem = 'updateItem',
  AddItem = 'addItem'
}